export default __webpack_public_path__ + "static/media/Sprite_Icon_Stat_04.9cf14331.png";